import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
interface CTAButtonProps {
  text?: string;
  subtext?: string;
  onClick?: () => void;
  className?: string;
}
export function CTAButton({
  text = 'SÍ, QUIERO MI RECETARIO ANCESTRAL AHORA',
  subtext = 'Acceso inmediato · Descarga digital · Garantía de 60 días',
  onClick,
  className = ''
}: CTAButtonProps) {
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      // Default behavior: scroll to offer section
      document.getElementById('oferta')?.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className={`flex flex-col items-center w-full max-w-xl mx-auto ${className}`} data-id="element-1">
      <button onClick={handleClick} className="group relative w-full bg-emerald-500 text-white border-2 border-emerald-400 rounded-xl py-5 px-6 md:px-8 shadow-lg hover:bg-emerald-400 hover:shadow-xl transition-all duration-300 overflow-hidden flex items-center justify-center gap-3" data-id="element-2">
        <div className="absolute inset-0 bg-ancestral-gold/10 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" data-id="element-3" />
        <span className="relative font-serif font-bold text-lg md:text-xl text-center uppercase tracking-wide" data-id="element-4">
          {text}
        </span>
        <ChevronRightIcon className="relative w-6 h-6 flex-shrink-0 group-hover:translate-x-1 transition-transform" data-id="element-5" />
      </button>
      {subtext && <p className="mt-3 text-sm md:text-base text-center opacity-80 font-medium flex items-center gap-2 flex-wrap justify-center" data-id="element-6">
          {subtext.split('·').map((part, i, arr) => <span key={i} className="flex items-center gap-2" data-id="element-7">
              {part.trim()}
              {i < arr.length - 1 && <span className="text-ancestral-gold hidden md:inline" data-id="element-8">·</span>}
            </span>)}
        </p>}
    </div>;
}